import { createFileRoute } from '@tanstack/react-router';
import { ApprovalsPage } from '@/features/spaces/pages/approvals-page';

/** Requests to let a member join a space of another organisation, waiting for an administrator. */
export const Route = createFileRoute('/_auth/o/$orgId/space-approvals')({
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  const { orgId } = Route.useParams();
  return <ApprovalsPage orgId={orgId} />;
}
